import { NavBar } from './NavBar'
import { ProgressStepper } from './ProgressStepper'
import { Footer } from './Footer'

interface PageShellProps {
  showStepper?: boolean
  currentStep?: 0 | 1 | 2 | 3 | 4
  children: React.ReactNode
}

export function PageShell({
  showStepper = false,
  currentStep = 0,
  children,
}: PageShellProps) {
  return (
    <div
      className="flex flex-col"
      style={{
        minHeight: '100svh',
        background: 'var(--color-surface-base)',
      }}
    >
      {/* Sticky navigation */}
      <NavBar />

      {/* Sticky stepper (desktop: sticky; mobile: fixed-bottom via ProgressStepper itself) */}
      {showStepper && <ProgressStepper currentStep={currentStep} />}

      {/* Main content area */}
      <main
        className="flex-1 mx-auto w-full"
        style={{
          maxWidth: 'var(--content-max-width)',
          paddingLeft: 'var(--page-padding-horizontal)',
          paddingRight: 'var(--page-padding-horizontal)',
          // 48px below the stepper to the page header; 32px when there's no
          // stepper (gap to the nav bar). Owned here so it can't drift per-screen.
          paddingTop: showStepper ? 'var(--spacing-12)' : 'var(--spacing-8)',
          // Extra bottom padding to avoid overlap with the mobile fixed stepper bar
          paddingBottom: showStepper ? 'var(--spacing-20)' : 'var(--spacing-10)',
        }}
      >
        {children}
      </main>

      {/* Footer */}
      <Footer />
    </div>
  )
}
